import React, { useEffect, useState } from "react";
import "./Form.css";
import logo from "./logo.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Form = () => {
  const [courseOptions, setCourseOptions] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    gender: "",
    location: "",
    contact_number: "",
    parent_contact: "",
    email: "",
    country: "",
    state: "",
    district: "",
    city: "",
    address: "",
    pin_code: "",
    course: "",
    batch_time: "",
    education_qualification: "",
    exact_fee: "",
    duration: "",
    documents_submitted: "",
    updated_by: "student",
  });
  const [photo, setPhoto] = useState(null);

  // ✅ Fetch course options
  const fetchCourseOptions = async () => {
    try {
      const response = await fetch(
        "https://software.iqjita.com/administration.php?action=getcoursedetails"
      );

      const text = await response.text();
      const jsonStartIndex = text.indexOf("{");
      const cleanJson =
        jsonStartIndex !== -1 ? text.slice(jsonStartIndex).trim() : text;

      const data = JSON.parse(cleanJson);

      if (data.status === "success") {
        const formattedCourses = data.courses.map((course) => ({
          name: course.course,
          exact_fee: parseFloat(course.exact_fee),
          duration: course.duration,
        }));
        setCourseOptions(formattedCourses);
      } else {
        console.error("❌ Failed to fetch courses:", data);
      }
    } catch (error) {
      console.error("🚨 Error fetching courses:", error.message);
    }
  };

  useEffect(() => {
    fetchCourseOptions();
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // ✅ Handle course selection → auto-fill exact_fee & duration
  const handleCourseChange = (e) => {
    const selectedCourseName = e.target.value;
    const selectedCourse = courseOptions.find(
      (course) => course.name === selectedCourseName
    );

    setFormData((prev) => ({
      ...prev,
      course: selectedCourseName,
      exact_fee: selectedCourse ? selectedCourse.exact_fee : "",
      duration: selectedCourse ? selectedCourse.duration : "",
    }));
  };

  // ✅ Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        submitData.append(key, value);
      });

      if (photo) {
        submitData.append("photo", photo);
      }

      const response = await fetch(
        "https://software.iqjita.com/admission.php",
        {
          method: "POST",
          body: submitData,
        }
      );

      const result = await response.json();
      console.log("📩 Server Response:", result);

      if (result.status === "success") {
        alert("✅ Student admission recorded successfully!");
      } else {
        alert("❌ Error: " + result.error);
        console.log("form data", formData);

      }
    } catch (error) {
      console.error("🚨 Submission failed:", error);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="form-main">
      <div className="logo">
        <img src={logo} alt="" />
      </div>
      <form onSubmit={handleSubmit} className="form-container">
        {/* Full Name */}
        <div className="form-input">
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Your Name..."
          />
        </div>

        {/* DOB */}
        <div className="form-input">
          <label>Date of Birth</label>
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
          />
        </div>

        {/* Gender */}
        <div className="form-input">
          <label>Gender</label>
          <div className="form-gender">
            {["male", "female", "other"].map((g) => (
              <div key={g}>
                <input
                  type="radio"
                  name="gender"
                  value={g}
                  checked={formData.gender === g}
                  onChange={handleChange}
                />
                <label>{g.charAt(0).toUpperCase() + g.slice(1)}</label>
              </div>
            ))}
          </div>
        </div>

        {/* Location */}
        <div className="form-input">
          <label>Location</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="Enter Your Location..."
          />
        </div>

        {/* Contact Number */}
        <div className="form-input">
          <label>Contact Number</label>
          <PhoneInput
            country="in"
            value={formData.contact_number}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, contact_number: value }))
            }
            inputProps={{ name: "contact_number" }}
            containerStyle={{ width: "100%" }}
            inputStyle={{ width: "100%", paddingLeft: "50px" }}
          />
        </div>

        {/* Photo */}
        <div className="form-input">
          <label>Photo</label>
          <input type="file" onChange={(e) => setPhoto(e.target.files[0])} />
        </div>

        {/* Parent Contact */}
        <div className="form-input">
          <label>Parent Contact</label>
          <PhoneInput
            country="in"
            value={formData.parent_contact}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, parent_contact: value }))
            }
            inputProps={{ name: "parent_contact" }}
            containerStyle={{ width: "100%" }}
            inputStyle={{ width: "100%", paddingLeft: "50px" }}
          />
        </div>

        {/* Email */}
        <div className="form-input">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Your Email..."
          />
        </div>

        {/* Country */}
        <div className="form-input">
          <label>Country</label>
          <input
            type="text"
            name="country"
            value={formData.country}
            onChange={handleChange}
            placeholder="Enter Your Country..."
          />
        </div>

        {/* State */}
        <div className="form-input">
          <label>State</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            placeholder="Enter Your State..."
          />
        </div>

        {/* District */}
        <div className="form-input">
          <label>District</label>
          <input
            type="text"
            name="district"
            value={formData.district}
            onChange={handleChange}
            placeholder="Enter Your District..."
          />
        </div>

        {/* City */}
        <div className="form-input">
          <label>City</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Enter Your City..."
          />
        </div>

        {/* Address */}
        <div className="form-input">
          <label>Address</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter Your Address..."
          />
        </div>

        {/* Pin Code */}
        <div className="form-input">
          <label>Pin Code</label>
          <input
            type="text"
            name="pin_code"
            value={formData.pin_code}
            onChange={handleChange}
            placeholder="Enter Your Pincode..."
          />
        </div>

        <div className="form-input">
          <label>Documents Submitted</label>
          <select
            name="documents_submitted"
            multiple
            value={formData.documents_submitted ? formData.documents_submitted.split(",") : []}
            onChange={(e) => {
              const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);
              setFormData((prev) => ({
                ...prev,
                documents_submitted: selectedOptions.join(","),
              }));
            }}
          >
            <option value="ID Proof">ID Proof</option>
            <option value="Birth Certificate">Birth Certificate</option>
            <option value="SSLC">SSLC</option>
            <option value="+2 Certificates">+2 Certificates</option>
            <option value="Passport">Passport</option>
          </select>
          {/* <small>Hold CTRL (Windows) or CMD (Mac) to select multiple</small> */}
        </div>



        {/* Course */}
        <div className="form-input">
          <label>Course</label>
          <select name="course" value={formData.course} onChange={handleCourseChange}>
            <option value="">Select Course</option>
            {courseOptions.map((course) => (
              <option key={course.name} value={course.name}>
                {course.name}
              </option>
            ))}
          </select>
        </div>

        {/* Exact Fee (auto-filled) */}
        {/* <div className="form-input">
          <label>Exact Fee</label> */}
        <input type="hidden" value={formData.exact_fee} readOnly />
        {/* </div> */}

        {/* Duration (auto-filled) */}
        {/* <div className="form-input">
          <label>Duration</label> */}
        <input type="hidden" value={formData.duration} readOnly />
        {/* </div> */}

        {/* Batch Time */}
        <div className="form-input">
          <label>Batch Time</label>
          <select
            name="batch_time"
            value={formData.batch_time}
            onChange={handleChange}
          >
            <option value="">Select Batch Time</option>
            <option value="9 AM - 11 AM">9 AM - 11 AM</option>
            <option value="11 AM - 1 PM">11 AM - 1 PM</option>
            <option value="2 PM - 4 PM">2 PM - 4 PM</option>
          </select>
        </div>

        {/* Education Qualification */}
        <div className="form-input">
          <label>Education Qualification</label>
          <select
            name="education_qualification"
            value={formData.education_qualification}
            onChange={handleChange}
          >
            <option value="">Select Qualification</option>
            <option value="High School">High School</option>
            <option value="High Secondary">High Secondary</option>
            <option value="Diploma">Diploma</option>
            <option value="Undergraduate">Undergraduate</option>
            <option value="Postgraduate">Postgraduate</option>
          </select>
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Form;
